import { USER_TYPE } from '../../../../utils/authorization'

export const SUBSCRIPTION_TYPES_KEYS = {
  STANDARD: USER_TYPE.STANDARD,
  PREMIUM: USER_TYPE.PREMIUM,
}

export const LIST_SUBCRIPTION_TYPES = [
  { title: 'Standard', value: SUBSCRIPTION_TYPES_KEYS.STANDARD },
  { title: 'Premium', value: SUBSCRIPTION_TYPES_KEYS.PREMIUM },
]

export const SUBSCRIPTION_TERMS_KEYS = {
  THREE_MONTHS: 3,
  SIX_MONTHS: 6,
  ONE_YEAR: 12,
  ONE_YEAR_NO: 1,
}

export const LIST_SUBCRIPTION_TERMS = [
  {
    title: SUBSCRIPTION_TERMS_KEYS.THREE_MONTHS,
    value: SUBSCRIPTION_TERMS_KEYS.THREE_MONTHS,
  },
  {
    title: SUBSCRIPTION_TERMS_KEYS.SIX_MONTHS,
    value: SUBSCRIPTION_TERMS_KEYS.SIX_MONTHS,
  },
  {
    title: SUBSCRIPTION_TERMS_KEYS.ONE_YEAR_NO,
    value: SUBSCRIPTION_TERMS_KEYS.ONE_YEAR,
  },
]
